import { combineReducers } from 'redux'

// reducers
import list from './list'
import fund from './fund'

export default combineReducers({ list, fund })



// WEBPACK FOOTER //
// ./src/store/reducers/funds/index.js